export const ROUTES = {
  LOGIN: '/login',
  FORGOT_PASSWORD: '/forgot-password',
  RESET_PASSWORD: '/reset-password',
  DASHBOARD: '/',
  PRODUCTS: '/products',
  PRODUCT_CREATE: '/products/new',
  PRODUCT_VIEW: '/products/:slug',
  PRODUCT_EDIT: '/products/:slug/edit',
  BRANDS: '/brands',
  BRAND_CREATE: '/brands/new',
  BRAND_EDIT: '/brands/:id/edit',
  CATEGORIES: '/categories',
  CATEGORY_CREATE: '/categories/new',
  CATEGORY_EDIT: '/categories/:id/edit',
  HERO_SLIDES: '/hero-slides',
  HERO_SLIDE_CREATE: '/hero-slides/new',
  HERO_SLIDE_EDIT: '/hero-slides/:id/edit',
  ORDERS: '/orders',
  ORDER_VIEW: '/orders/:id',
  USERS: '/users',
  USER_VIEW: '/users/:id',
  SETTINGS: '/settings',
  SETTINGS_CONTACTS: '/settings/contacts',
  SETTINGS_SECURITY: '/settings/security',
};
